import { CSSProperties } from "react";
import { useIntl } from "react-intl";

import { ReactComponent as FanSVG } from "../../assets/fan.svg";
import { ReactComponent as OfflineSVG } from "../../assets/offline.svg";

const configByStatus = {
  offline: {
    Icon: OfflineSVG,
    label: { id: "device.status.offline" },
    bgColor: "#333333",
    textColor: "var(--outline-color)",
  },
  evconnected: {
    bgColor: "#E5E8E8",
    textColor: "#0E0E0E",
    label: { id: "device.status.connected" },
  },
  charging: {
    Icon: FanSVG,
    label: { id: "device.status.charging" },
    bgColor: "rgba(255, 113, 0, 0.2)",
    textColor: "var(--icon-fill-color)",
  },
  error: {
    label: { id: "device.status.error" },
    bgColor: "rgba(245, 46, 46, 0.1)",
    textColor: "#f52e2e",
  },
} as any;

function DeviceStatus({ status }: { status: any }) {
  const { formatMessage } = useIntl();
  const config = configByStatus[status];

  if (config == null) return null;

  const { Icon, label, bgColor, textColor } = config;

  return (
    <div className="device-status">
      <div
        className="status"
        style={
          {
            "--bg-color": bgColor,
            "--active-text-color": textColor,
          } as CSSProperties
        }
      >
        {Icon && <Icon />}
        <span className="status-text">{formatMessage(label)}</span>
      </div>
    </div>
  );
}

export default DeviceStatus;
